/* eslint-disable react/require-default-props */
import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

import Box, { Types as BoxTypes } from './Box'

const Rows = forwardRef(({ children, gap = 16, ...rest }, ref) => (
  <Box ref={ref} gap={gap} type={BoxTypes.ROWS} {...rest}>{children}</Box>
))

Rows.propTypes = {
  children: PropTypes.node,
  gap: PropTypes.number,
}

export default Rows
